var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsCl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 6 4",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h6v4H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M0 2V0h2v3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d72b1f",
    d: "M0 2h6v2H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1 .5.294.904-.77-.558h.952l-.77.559z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsCl);
export default __webpack_public_path__ + "static/media/es-CL.42281a347a57dba5f76c2671331e0a87.svg";
export { ForwardRef as ReactComponent };